import Header from './Header'
import Footer from './Footer'
import PfpStudio from './PfpStudio'

export default function PfpStudioPage() {
    return (
        <div className="min-h-screen flex flex-col bg-ugandan-black overflow-x-hidden pt-20">
            <Header />
            <main className="flex-grow">
                <PfpStudio />
            </main>
            <Footer />
        </div>
    )
}
